var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.hasNav)?_c('Navigation',{ref:"nav",attrs:{"isShow":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }